module.exports = __webpack_public_path__ + "img/weddingbands@2x.79a57e9.jpg";